import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { uploadFile } from "../../../../apis/common-apis/fileApi";
import { Slide } from "@mui/material";

export const usePeopleEvidenceUpload = (check, refetch, setSnackbarInfo) => {
  const [isLoading, setIsLoading] = useState(false);
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const TransitionComponent = (props) => {
    return <Slide {...props} direction="left" />;
  };
  const handlePeopleEvidenceUpload = async (file, fileType) => {
    setIsLoading(true);
    const relatedEntityId = check?.checkId;

    if (!file || !relatedEntityId) {
      setSnackbarInfo({
        message: "Invalid file or check ID! Please try again.",
        vertical: "top",
        horizontal: "right",
        Transition: TransitionComponent,
      });
      setIsLoading(false);
      return;
    }

    try {
      const accessToken = await getAccessTokenSilently();
      const idToken = (await getIdTokenClaims()).__raw;

      const response = await uploadFile(
        file,
        fileType,
        check?.checkId,
        undefined,
        accessToken,
        idToken,
        check?.ownerEmployeeId,
        true
      );

      await refetch();
      return response;
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handlePeopleEvidenceUpload,
  };
};
